<template>
    <modal
        :saveAction="createDispatch"
        :title="$t(title)"
        :id="id"
        :deleteAction="false"
        :actionButtons="true"
        size="md"
        :closeButton="hide"
        @shown="shown"
        @hidden="hidden"
    >
    </modal>
</template>

<script>
    import Modal from "@/components/Modal";

    export default {
        name: "DispatchModal",
        props: {id: String},
        components: {Modal},
        data() {
            return {
                title: ''
            }
        },
        methods: {
            hide() {
                this.$root.$emit('bv::hide::modal', this.id)
            },

            shown() {

            },

            hidden() {

            }
        }
    }
</script>

<style scoped>

</style>
